import request from '../utils/request'

export function selectGoodsList(data) {
  return request({
    url: '/api/goods/list',
    method: 'post',
    data,
  })
}
export function fetchGoods(data) {
  return request({
    url: '/api/goods/fetch',
    method: 'post',
    data,
  })
}
